import { getUser, setUser } from '@utils/storage.js';
import { UPDATEUER, REMOVEUSER } from '../types';
export default {
  namespaced: true,
  state: {
    userInfo: getUser()
  },
  mutations: {
    [UPDATEUER] (state, userInfo) {
      console.log(state.userInfo);
      state.userInfo = Object.assign({}, state.userInfo, userInfo);
      setUser(state.userInfo);
    },
    [REMOVEUSER] (state) {
      state.userInfo = {};
      setUser('');
    }
  },
  actions: {
    updateUser ({ commit }, userInfo) {
      if (userInfo.zpUser != null && userInfo.zpUser.id != null) {
        userInfo = userInfo.zpUser;
      }
      commit(UPDATEUER, userInfo);
    },
    removeUser ({ commit }) {
      commit(REMOVEUSER);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js